import {
  Button,
  Divider,
  CircularProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import { AddLabel } from "./AddLabel";
import baseURL from "../../../configs/api";
import axios from "axios";
import useConfirm from "../../../components/hooks/useConfirm";
import { useTheme } from "../../../components/hooks/useTheme";
import useDelete from "../../../components/hooks/useDelete";
import PleaseWaitPopup from "../../PleaseWaitPopup";
import colorConfigs from "../../../configs/colorConfigs";
import useAuth from "../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";

export const UserRoles = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { themeStyles } = useTheme();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const { setDeletePopup, setData: setDeleteData }: any = useDelete();
  const [tableData, setTableData] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isAdded, setAdded] = useState(false);
  const [id, setId] = useState<number>();
  const [roleName, setRoleName] = useState("");
  const [roleDescription, setRoleDescription] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState(false);
  const [isRoleNameChanged, setIsRoleNameChanged] = useState<boolean>(false);

  useEffect(() => {
    if (!isProcessing && !isDataLoaded) {
      fetch(`${baseURL}roles`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
        .then((res) => res.json())
        .then((data) => {
          setIsDataLoaded(true);
          setTableData(data);
          handleTenantError(null);
        })
        .catch((error) => {
          setTableData([]);
          setIsDataLoaded(true);
          handleTenantError(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProcessing]);

  const deletingRole = async (id: number) => {
    setDeleteData({
      id: id,
      tilte: `Delete`,
      summary: `Are you sure you want to delete this User Role?`,
      isDelete: (callback: any) => {
        setPleaseWaitPopup(true);
        callback();

        axios.delete(`${baseURL}roles?id=${id}&userId=${auth?.id}`, {
          headers: {
            'X-Tenant-ID': tenantId,
          }
        })
          .then(() => {
            setTableData(() => tableData?.filter((_: any) => _?.id !== id));
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            setConfirmData({
              title: 'Warning',
              summary: error.response.data,
              confirmBtn: 'Ok',
              isConfirm: (cb: any) => {
                cb();
              }
            });

            setConfirmPopup(true);
            setPleaseWaitPopup(false);

            handleTenantError(error);
          })
      }
    });
    setDeletePopup(true);
  };

  const ChangeHandle = async (id: number, changedRoleName: string, roleDescription: string, isActive: boolean) => {
    setId(id);
    tableData?.find((item: any) => item?.roleName?.trim()?.toLocaleLowerCase() === changedRoleName?.trim()?.toLocaleLowerCase() && item?.id !== id) ? setIsRoleNameChanged(true) : setIsRoleNameChanged(false);
    setRoleName(changedRoleName.trim());
    setRoleDescription(roleDescription);
    setIsActive(isActive);
  }

  const saveNewRow = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!isProcessing) {
      if (!isAdded) {
        setPleaseWaitPopup(true);
        if (!isRoleNameChanged || !tableData?.find((item: any) => item?.roleName?.trim()?.toLocaleLowerCase() === roleName?.trim()?.toLocaleLowerCase())) {
          setIsProcessing(true);
          axios
            .put(
              `${baseURL}roles?userId=${auth?.id}`,
              JSON.stringify({
                id,
                roleName,
                roleDescription,
                isActive,
              }),
              {
                headers: {
                  'X-Tenant-ID': tenantId,
                  "Content-Type": "application/json"
                },
                withCredentials: true,
              }
            )
            .then(() => {
              setIsProcessing(false);
              setPleaseWaitPopup(false);
              setIsDataLoaded(false);
              handleTenantError(null);
            })
            .catch((error) => {
              setPleaseWaitPopup(false);
              handleTenantError(error);
            });
        } else {
          setPleaseWaitPopup(false);
          setConfirmPopup(true);
          setConfirmData({
            title: `Same roles are not allowed!`,
            summary: '',
            confirmBtn: 'OK',
            isConfirm: (callback: any) => {
              callback();
            }
          });
        }
      } else {
        setPleaseWaitPopup(true);
        if (!tableData?.find((item: any) => item?.roleName?.trim()?.toLocaleLowerCase() === roleName?.trim()?.toLocaleLowerCase())) {
          setIsProcessing(true);
          await axios
            .post(
              `${baseURL}roles?userId=${auth?.id}`,
              JSON.stringify({
                roleName,
                roleDescription,
                isActive,
              }),
              {
                headers: {
                  'X-Tenant-ID': tenantId,
                  "Content-Type": "application/json"
                },
                withCredentials: true,
              }
            )
            .then(() => {
              setAdded(false);
              setIsProcessing(false);
              setPleaseWaitPopup(false);
              setIsDataLoaded(false);
              handleTenantError(null);
            })
            .catch((error) => {
              setPleaseWaitPopup(false);
              handleTenantError(error);
            });
        } else {
          setPleaseWaitPopup(false);
          setConfirmPopup(true);
          setConfirmData({
            title: `Same roles are not allowed!`,
            summary: '',
            confirmBtn: 'OK',
            isConfirm: (callback: any) => {
              callback();
            }
          });
        }

      }
    }
  };

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>

        <div className="w-full mt-2">
          <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>User Roles</h2>
        </div>

        <div className="w-full mt-4">
          <div className="w-full flex flex-row px-6 mb-2">
            <div className={`w-1/2 text-sm ${themeStyles.main.textHeadingColor} font-semibold`}>Label</div>

            <div className={`w-1/2 text-sm ${themeStyles.main.textHeadingColor} font-semibold`}>Handle</div>

            <div className={`w-[10%] text-sm ${themeStyles.main.textHeadingColor} font-semibold`}>Active?</div>

            <div className={`w-[5%]`}>
              <span className={`material-symbols-outlined text-[25px] font-medium text-red-500`}>
                delete
              </span>
            </div>
          </div>

          <Divider className={`w-full ${themeStyles.divider.bg}`} />

          <div className="mt-2">
            {
              isDataLoaded ? (
                tableData?.map((item: any) => (
                  <AddLabel
                    key={item.id}
                    data={item}
                    handleDelete={(id) => deletingRole(id)}
                    handleTheChange={(
                      id,
                      roleName,
                      roleDescription,
                      isActive,
                    ) =>
                      ChangeHandle(
                        id,
                        roleName,
                        roleDescription,
                        isActive,
                      )
                    }
                  />
                ))
              ) : (
                <div className="flex flex-col items-center justify-center gap-2 py-4">
                  <CircularProgress />
                </div>
              )
            }

            {
              isDataLoaded && (
                <form onSubmit={(e) => saveNewRow(e)}>
                  {
                    isAdded && (
                      <div className={`w-full flex flex-row justify-center items-center px-6 bg-transparent mb-2`}>
                        {/* Label */}
                        <div className="w-1/2 mr-2">
                          <input
                            type="text"
                            name="label"
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={roleName}
                            onChange={(e) => setRoleName(e.target.value)}
                            required
                          />
                        </div>

                        {/* Handle */}
                        <div className="w-1/2 mr-2">
                          <input
                            type="text"
                            name="handle"
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={roleDescription}
                            onChange={(e) => setRoleDescription(e.target.value)}
                            required
                          />
                        </div>

                        {/* Active */}
                        <div className="w-[10%] mr-2">
                          <select
                            name="active"
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={isActive ? "Yes" : "No"}
                            onChange={(e) => setIsActive(e.target.value === "Yes")}
                          >
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                        </div>

                        {/* Delete Icon */}
                        <div className="w-[5%]">
                          <span className={`material-symbols-outlined text-[25px] font-medium text-red-500 cursor-pointer`}
                            onClick={() => {
                              setAdded(false);
                            }}
                          >
                            delete
                          </span>
                        </div>
                      </div>
                    )
                  }

                  {/* Buttons Section */}
                  <div className="h-[50px] flex flex-row items-center gap-2 rounded-b px-8">
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: colorConfigs.btn.main.bg
                      }}
                      onClick={() => {
                        setId(0);
                        setRoleName("");
                        setRoleDescription("");
                        setIsActive(true);
                        setAdded(true);
                      }}
                    >
                      Add Row
                    </Button>

                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: colorConfigs.btn.main.bg
                      }}
                      type="submit"
                    >
                      Save
                    </Button>
                  </div>
                </form>
              )
            }
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </div>
  );
};

